export function localStorageProvider() {
  const map = new Map<string, any>(JSON.parse(localStorage.getItem('app-cache') || '[]'));

  window.addEventListener('beforeunload', () => {
    const appCache = JSON.stringify(Array.from(map.entries()));
    localStorage.setItem('app-cache', appCache);
  });

  return {
    get: (key: string) => map.get(key),
    set: (key: string, value: any) => {
      map.set(key, value);
      return value;
    },
    delete: (key: string) => {
      const hadKey = map.has(key);
      map.delete(key);
      return hadKey;
    },
    keys: () => map.keys(),
  };
}


/* THIS COMPONENT MAY BE BROKEN */